
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.983 15.044l7.99-7.99 2.97 2.97-7.99 7.99zM20 7l-2 2-3-3 2-2c.6-.6 2 1 2 1s1.6 1.4 1 2zM8 19c-1 .5-2 .8-3 1-1 .1-1.1 0-1-1 .2-1 .5-2.1 1-3l3 3z"}}),_c('path',{attrs:{"d":"M9.03 12L12 9.03 14.97 12 12 14.97zm2.27-3.7l-1.1-1.1-1 1-.4-.4 1-1-1.6-1.6-1 1-.4-.4 1-1L7 4 4 7l4.3 4.3zm6.9 8.9l-.4-.4 1-1-1.6-1.6-1 1-.4-.4 1-1-1.1-1.1-3 3L17 20l3-3-.8-.8z"}})])
          )
        }
      }
    